import { graphql } from 'react-relay';

export const gqlSetPoshmarkBotListingsOfferConfiguration = graphql`
  mutation setPoshmarkBotListingsOfferConfigurationMutation($listingIds: [String!]!, $offerConfigId: String) {
    poshmarkSetBotListingsOfferConfiguration(listingIds: $listingIds, offerConfigId: $offerConfigId) {
      success
    }
  }
`;
